import React from "react";
import { PlusCircle, Upload, BarChart2 } from "lucide-react";
import { Button } from "@shared/ui/button";
import { Link } from "react-router-dom";

interface MasterPageHeaderProps {
  onCreateSopClick: () => void;
  onBulkUploadClick: () => void;
}

const MasterPageHeader: React.FC<MasterPageHeaderProps> = ({
  onCreateSopClick,
  onBulkUploadClick,
}) => {
  return (
    <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
      {/* Page Title and Description */}
      <div>
        <h1 className="page-title">Master</h1>
        <p className="page-subtitle">
          Manage SOP templates, assets and configurations
        </p>
      </div>

      {/* Action Buttons */}
      <div className="flex flex-col md:flex-row gap-3 w-full md:w-auto">
        <Button onClick={onCreateSopClick}>
          <PlusCircle className="mr-2 h-4 w-4" />
          Create SOP
        </Button>

        {/* <Button variant="outline" onClick={onBulkUploadClick}>
          <Upload className="mr-2 h-4 w-4" />
          Bulk Upload
        </Button> */}
      </div>
    </div>
  );
};

export default MasterPageHeader;
